"use strict";

import data from "../data/cards";
import cookie from "../util/cookie";
import slider from "./slider.js";
import links from "../components/links";
import { pushDataLayerCard } from "../util/pushDataLayer.js";

let url = document.location.href;
let isMeuVivo = url.indexOf("cliente-especial-meuvivo") > -1;

let params = new URLSearchParams(window.location.search);
const regional = params.get("regional") || "nacional";
const paramAction = params.get("acao");
const paramPlan = params.get("plano");
const isAction =
  paramAction === "migradotz" ||
  paramAction === "vivopay1" ||
  paramAction === "vivopay2" ||
  paramAction === "vivopay3";

import getCurrentLp from "../util/getCurrentLp";

let groups = require("../regionalization/cards.json");

let template = `<div class="item">
        <div class="cards--card {{borderFlag}}">
            <div class="cards--card--plan">
            <div data-id="{{id}}"></div>
                <div class="cards--card--plan--flag" style="{{flag}}">
                    {{flagText}}
                </div>
                <h3 class="cards--card--plan--gigas" data-normal="{{gigas}}" data-redes="{{gigasRedes}}">{{gigas}}</h3>
                <span class="cards--card--plan--gigas--detail">{{bonus}}</span>
                <span class="cards--card--plan--gigas--bonusPurple" style="{{styleBonusPurple}}">{{bonusPurple}}</span>
                <span class="cards--card--plan--gigas--subDetail" style="{{styleSubDetail}}">{{subDetail}}</span>
                <h4 class="cards--card--plan--price" data-normal="{{price}}" data-redes="{{priceRedes}}">{{price}} </h4>
                <p class="cards--card--plan--subtitle" style="{{permanencia}}">{{permanenciaText}}</p>
                <a class="cards--card--plan--assine" target="_blank" data-link="{{link}}" data-linknormal="{{normalParam}}" data-linkredes="{{redesParam}}" href="{{linkDefault}}">Contratar</a>
            </div>
            <div class="cards--card--details">  
                <div class="cards--card--details--toggle">
                    <button class="cards--card--details--toggle--btn">Toggle</button>
                    <div class="cards--card--details--toggle--label">Adicione {{gigasRedesAdicionais}} {{gigasRedesAdicionaisPreco}}</div>
                </div> 
                <div class="cards--card--details--network">
                  {{imagesRedes}}
                </div>
                <div class="cards--card--details--separator-full"><span></span></div>

                <div class="cards--card--details--streaming" style="{{styleAction}}">
                  <p class="cards--card--details--vantagens--title">{{action-title}}</p>
                  <p class="cards--card--details--vantagens--desc">{{action-description}}</p>
                  <img src="{{action-icon}}" alt="{{action-altIcon}}" />
                  <div class="cards--card--details--separator"></div>
                </div>
                <!-- Big Amazon -->
                <!-- <div class="cards--card--details--vantagens" style="margin-bottom:15px;">
                    <p class="cards--card--details--vantagens--title">Assinatura Amazon Prime</p>
                    <p class="cards--card--details--vantagens--desc">6 meses de Amazon Prime de presente</p>
                    <img src="./assets/img/app-amazon-prime-252x252.png" alt="Logo do aplicativo Amazon Prime">
                </div> -->
                {{arrayStreaming}}
                <div class="cards--card--details--apps">
                    <p class="cards--card--details--apps--title">Meia entrada na Cinemark todos os meses</p>
                    <img src="./assets/img/logo-cinemark-252x252.png" alt="Logo da Cinemark">
                </div> 
                <div class="cards--card--details--apps">
                    <p class="cards--card--details--apps--title">Apps ilimitados</p>
                    {{imagesApps}}
                </div> 
                <div class="cards--card--details--vantagens">
                    <h4 class="cards--card--details--vantagens--title">Ligações ilimitadas</h4>
                    <p class="cards--card--details--vantagens--desc">{{ligacoes}}</p>
                    <h4 class="cards--card--details--vantagens--title">{{apps_inclusos_title}}</h4>
                    <p class="cards--card--details--vantagens--desc">{{appsInclusos}}</p>
                    <h4 class="cards--card--details--vantagens--title">Vivo Valoriza</h4>
                    <p class="cards--card--details--vantagens--desc">Descontos, gratuidades e diversas experiências para você aproveitar</p>
                    <img src="./assets/img/icon-vivo-valoriza.png" alt="Logo Vivo Valoriza" /> 
                </div>
            </div>
        </div>
        <div class="cards--card--texto-legal" style="{{textoLegal}}" data-normal="{{textoLegalText}}" data-redes="{{textoLegalTextRedes}}">{{textoLegalText}}</div>
    </div>`;

export default {
  bind: () => {
    let $btns = document.querySelectorAll(".cards--card--details--toggle--btn");
    let $ctas = document.querySelectorAll(".cards--card--plan--assine");

    $btns.forEach(($btn, index) => {
      $btn.addEventListener("click", (event) => {
        let $items = document.querySelectorAll(".item"),
          // $redes = event.target
          //   .closest(".cards--card--details")
          //   .querySelector(".cards--card--details--redes"),
          $plan = event.target.closest(".cards--card").querySelector(".cards--card--plan"),
          $obs = document.querySelector(".item").lastElementChild,
          rede,
          ga = cookie.readCookie("_ga") ? `&_ga=${cookie.readCookie("_ga")}` : "";

        if ($btn.classList.contains("active")) {
          $btn.classList.remove("active");
          // $redes.classList.remove("active");
          $obs.classList.remove("active");
          rede = "normal";
        } else {
          $btn.classList.add("active");
          // $redes.classList.add("active");
          $obs.classList.add("active");
          rede = "redes";
        }

        /**
         * Set data normal / redes
         */
        let $card = $btn.closest(".cards--card");
        let $elms = $card.querySelectorAll("[data-normal]");
        $elms.forEach(($elm) => {
          $elm.innerHTML = $elm.getAttribute(`data-${rede}`);
        });

        /**
         * Set link normal / redes
         */

        let $links = $plan.querySelectorAll("[data-link]");
        let $ids = $plan.querySelectorAll("[data-id]");

        $links.forEach(($link) => {
          if (groups[regional]) {
            $ids.forEach(($item) => {
              groups[regional].map((group) => {
                let actionLink;
                let defaultLink;

                if (isAction) {
                  actionLink =
                    group[paramAction][$item.getAttribute("data-id")].links[getCurrentLp()];
                } else {
                  defaultLink = group[$item.getAttribute("data-id")].links[getCurrentLp()];
                }

                if ($btn.classList.contains("active")) {
                  if (isAction) {
                    $link.setAttribute("href", actionLink.doubleRedes + links.getParams() + ga);
                  } else {
                    $link.setAttribute("href", defaultLink.doubleRedes + links.getParams() + ga);
                  }
                } else {
                  if (isAction) {
                    $link.setAttribute("href", actionLink.default + links.getParams() + ga);
                  } else {
                    $link.setAttribute("href", defaultLink.default + links.getParams() + ga);
                  }
                }
              });
            });
          } else {
            $link.setAttribute(
              "href",
              $link.getAttribute(`data-link`) +
              $link.getAttribute(`data-link${rede}`) +
              links.getParams() +
              ga
            );
          }
        });

        const card = event.target.closest(".cards--card");
        const cardInfo = [
          {
            type: "productclick",
            innerType: "toggle",
            index,
            id: card.querySelector("[data-id]").dataset.id,
            hasDoubleRedes: $btn.classList.contains("active"),
          },
        ];

        pushDataLayerCard(cardInfo);
      });

      /**
       * set checked double redes
       */
      if (url.search(/doubleredes=true/gi) > -1) {
        $btn.click();
      }
    });

    $ctas.forEach(($cta, index) => {
      $cta.addEventListener("click", (event) => {
        const card = event.target.closest(".cards--card");
        const cardInfo = [
          {
            type: "productclick",
            innerType: "cta",
            index,
            id: card.querySelector("[data-id]").dataset.id,
            hasDoubleRedes: $btns[index].classList.contains("active"),
          },
        ];

        pushDataLayerCard(cardInfo);
      });
    });
  },
  buildCards: () => {
    let $mensal = document.querySelector('[data-card="mensal"]'),
      $anual = document.querySelector('[data-card="anual"]'),
      dataCards = data.getData(),
      mensalData = dataCards.mensal ? dataCards.mensal : dataCards,
      anualData = dataCards.anual ? dataCards.anual : [];

    $mensal.innerHTML = "";
    $anual.innerHTML = "";

    const makeCard = (item) => {
      let card = template;
      let socialnetwork = "";
      let arrayStreaming = "";
      let apps = "";

      item.redes_sociais.map((image) => {
        socialnetwork += `<img src="${image.icon}" alt="${image.title}"/>`;
      });

      if (item.streaming) {
        item.streaming.map((streaming) => {
          arrayStreaming += `
          <div class="cards--card--details--streaming">
            <p class="cards--card--details--streaming--desc">
              ${streaming.title}
              <p class="cards--card--details--vantagens--desc">
                ${streaming.subtitle}
              </p>
              <a
                class="cards--card--details--streaming--desc"
                href="${streaming.link}" 
                style="${streaming.link ? "display: block" : "display: none"}"
              > Saiba mais aqui </a>
            </p>
            <img src=${streaming.icon} alt=${streaming.altIcon} /> 
          </div>
        `;
        });
      }

      item.apps_ilimitados.map((image) => {
        apps += `<img src="${image.icon}" alt="${image.title}"/>`;
      });

      let showFlag = "display: none";
      if (item.flag && !isMeuVivo) {
        showFlag = "display: block";
      }
      if (item.flagMeuVivo && isMeuVivo) {
        showFlag = "display: block";
      }

      // if (((isCaptive && !item.offer) || is29M) && !isMeuVivo && !is34v2) {
      //   item.bonus_oferta = "";
      // }

      let ga = cookie.readCookie("_ga") ? `&_ga=${cookie.readCookie("_ga")}` : "";

      return (
        card
          .replace(/{{flag}}/gi, item.flag ? showFlag : isMeuVivo ? showFlag : "display: none")
          .replace(/{{borderFlag}}/gi, showFlag === "display: block" ? "borderFlag" : "")
          .replace(/{{flagText}}/gi, isMeuVivo ? item.flagMeuVivo : item.flag)

          //section Text Action
          .replace(/{{action-title}}/gi, item.action ? item.action.title : "")
          .replace(/{{action-description}}/gi, item.action ? item.action.description : "")
          .replace(/{{action-icon}}/gi, item.action ? item.action.icon : "")
          .replace(/{{action-altIcon}}/gi, item.action ? item.action.altIcon : "")
          .replace(/{{styleAction}}/gi, item.action ? "display: block" : "display: none")

          //section Streaming
          .replace(/{{arrayStreaming}}/gi, arrayStreaming)

          //section Social Network
          .replace(/{{imagesRedes}}/gi, socialnetwork)
          // .replace(/{{imagesStreaming}}/gi, streaming)
          .replace(/{{imagesApps}}/gi, apps)

          .replace(/{{gigas}}/gi, item.plan_sem_redes)
          .replace(/{{gigasRedes}}/gi, item.plan)

          .replace(/{{styleSubDetail}}/gi, item.subDetail ? "display:block" : "display:none")
          .replace(/{{subDetail}}/gi, item.subDetail)

          .replace(/{{bonus}}/gi, item.offer ? item.bonus_oferta : item.bonus)

          .replace(/{{styleBonusPurple}}/gi, item.bonusPurple ? "display:block" : "display:none")
          .replace(/{{bonusPurple}}/gi, item.bonusPurple)

          .replace(/{{price}}/gi, item.price_sem_redes)
          .replace(/{{priceRedes}}/gi, item.price)

          .replace(/{{permanencia}}/gi, item.permanencia ? "display: block" : "display: none")
          .replace(/{{id}}/gi, item.id)
          .replace(/{{permanenciaText}}/gi, item.permanencia)

          .replace(/{{linkDefault}}/gi, item.link + links.getParams() + ga)
          .replace(/{{link}}/gi, item.link + links.getParams() + ga)

          .replace(/{{gigasRedesAdicionais}}/gi, item.gbRedesSociais)
          .replace(/{{gigasRedesAdicionaisPreco}}/gi, item.txtRedesSociais)

          .replace(/{{apps_inclusos_title}}/gi, item.apps_inclusos_title)
          .replace(/{{appsInclusos}}/gi, item.apps_inclusos)

          .replace(/{{ligacoes}}/gi, item.ligacoes)

          .replace(/{{textoLegal}}/gi, item.desc_legal.redes ? "display: block" : "display: none")
          .replace(/{{textoLegalTextRedes}}/gi, item.desc_legal.redes)
          .replace(/{{textoLegalText}}/gi, item.desc_legal.normal)
          .replace(/{{streamingText}}/gi, item.streamingText)
      );
    };

    mensalData.map((item) => {
      $mensal.innerHTML += makeCard(item);
    });

    anualData.map((item) => {
      $anual.innerHTML += makeCard(item);
    });

    /**
     * slider
     */
    if (window.innerWidth <= 760) {
      mensalData.length && slider.buildSliderPlanoMensal();
      anualData.length && slider.buildSliderPlanoAnual();

      window.addEventListener("scroll", (e) => {
        let minTop = 170,
          wY = window.scrollY,
          $cards = document.querySelectorAll(".tns-outer");

        $cards.forEach(($card) => {
          let $controlPrev = $card.querySelector('.tns-controls [data-controls="prev"]'),
            $controlNext = $card.querySelector('.tns-controls [data-controls="next"]');

          if (wY > $card.offsetTop && wY < $card.offsetTop + $card.offsetHeight - 100) {
            $controlPrev.style.top =
              wY - $card.offsetHeight + 250 >= minTop
                ? wY - $card.offsetHeight + 250 + "px"
                : minTop + "px";
            $controlNext.style.top =
              wY - $card.offsetHeight + 250 >= minTop
                ? wY - $card.offsetHeight + 250 + "px"
                : minTop + "px";
          } else {
            $controlPrev.style.top = minTop + "px";
            $controlNext.style.top = minTop + "px";
          }
        });
      });

      const cards = document.querySelectorAll(".cards .item.tns-slide-active");
      const cardsIds = Array.from(cards).map((card) => {
        return {
          type: "impression",
          id: card.querySelector("[data-id]").dataset.id,
          hasDoubleRedes: location.search.includes("doubleredes=true"),
        };
      });

      pushDataLayerCard(cardsIds);
    } else {
      let cardsNode = document.querySelectorAll("[data-card]");
      cardsNode[0].classList.add("show");

      const cards = document.querySelectorAll(".cards .item");
      const cardsIds = Array.from(cards).map((card) => {
        return {
          type: "impression",
          id: card.querySelector("[data-id]").dataset.id,
          hasDoubleRedes: location.search.includes("doubleredes=true"),
        };
      });

      pushDataLayerCard(cardsIds);
    }
  },
};
